export default "__VITE_ASSET__DrPOFm2Q__"